export default __webpack_public_path__ + "static/media/header-img.c0b14cde.jpg";